import React from "react";
import Carouselcomp from "../components/Carouselcomp";

function Home() {
  return (
    <div className="comp-list-home">
      <Carouselcomp />
    </div>
  );
}

export default Home;
